<template>
  <b-modal
    :active.sync="isOpen"
    :width="width"
    scroll="keep"
    :can-cancel="canCancel"
    :class="{ 'modal-wrapper--bare': bare }"
    :custom-content-class="overflowVisible ? 'modal-wrapper__content--overflow' : ''"
  >
    <!-- Modo bare: el componente hijo trae su propio chrome (estilo Facebook). -->
    <component
      v-if="bare && component"
      :is="component"
      v-bind="componentProps"
      v-on="componentListeners"
      @close="hide"
    />

    <div v-else class="rounded-lg shadow-xl bg-white overflow-visible border border-gray-200">
      <header class="flex justify-between items-center px-4 py-3 border-b border-gray-200">
        <h2 class="text-sm font-semibold text-gray-800 uppercase tracking-wide">
          {{ title }}
        </h2>
        <button class="text-gray-400 hover:text-gray-700" @click="hide">
          <b-icon pack="fas" icon="times" size="is-small"></b-icon>
        </button>
      </header>

      <div class="px-4 py-4 bg-white">
        <component
          v-if="component"
          :is="component"
          v-bind="componentProps"
          v-on="componentListeners"
          @close="hide"
        />
      </div>
    </div>
  </b-modal>
</template>

<script>
/**
 * Modal genérico que renderiza cualquier componente Vue adentro.
 * El componente cargado debe emitir 'close' cuando termina su acción para
 * que el wrapper cierre automáticamente.
 *
 * Uso:
 *   <modal-wrapper ref="modal" />
 *
 *   this.$refs.modal.show({
 *     component: MyComponent,
 *     title: 'Algún título',
 *     props: { foo: 'bar' },
 *     listeners: { 'custom-event': (data) => ... },  // opcional
 *     width: 720,                                     // opcional
 *     bare: true,                                     // opcional: sin chrome del wrapper
 *   });
 */
export default {
  name: 'ModalWrapper',

  data() {
    return {
      isOpen:             false,
      component:          null,
      componentProps:     {},
      componentListeners: {},
      title:              '',
      width:              640,
      canCancel:          ['escape', 'x'],
      bare:               false,
      // Permite que el contenido del modal desborde (overflow visible) para que
      // los desplegables (p. ej. vue-multiselect) no queden recortados por la
      // caja del modal. Solo se activa bajo demanda para no romper el scroll
      // interno de modales altos.
      overflowVisible:    false,
    };
  },

  methods: {
    show({ component, props = {}, listeners = {}, title = '', width = 640, canCancel = ['escape', 'x'], bare = false, overflowVisible = false }) {
      this.component          = component;
      this.componentProps     = props;
      this.componentListeners = listeners;
      this.title              = title;
      this.width              = width;
      this.canCancel          = canCancel;
      this.bare               = bare;
      this.overflowVisible    = overflowVisible;
      this.isOpen             = true;
    },

    hide() {
      this.isOpen = false;
      this.$nextTick(() => {
        this.component          = null;
        this.componentProps     = {};
        this.componentListeners = {};
        this.title              = '';
        this.bare               = false;
        this.overflowVisible    = false;
      });
    },
  },
};
</script>

<!--
  Estilo global (NO scoped): la clase se inyecta en el .animation-content/.modal-content
  interno de Buefy (vía custom-content-class), que por defecto tiene overflow:auto y recorta
  los desplegables. Al ponerlo en visible, la lista del multiselect se superpone sobre el modal.
-->
<style>
.modal-wrapper__content--overflow {
  overflow: visible !important;
}
</style>
